import React, { Component } from 'react';

import Modal from '../../components/common/modal/Modal';
import Icon from '../../components/common/icon/Icon';

class ProductCard extends Component {
  constructor() {
    super();
    this.state = { isMediaPopupOpen: false };
  }

  render() {
    const { isMediaPopupOpen } = this.state;
    const { media, title, originalPrice, price, expiry } = this.props;
    return (
      <div>
        <Modal
          className="media-popup"
          open={isMediaPopupOpen}
          onClose={() => this.setState({ isMediaPopupOpen: false })}
        >
          {this.props.media}
        </Modal>
        <div className="product-card">
          <a href="#" onClick={() => this.setState({ isMediaPopupOpen: true })}>{media}</a>
          <div className="item-details">
            <h3>{title}</h3>
            {price ? <h4><span><Icon name="rupee" /> </span>{price}</h4> : '' }
            <div className="price-discount">
              {price ? <strike><span><Icon name="rupee" /> </span>{originalPrice}</strike> : ''}
              {price && originalPrice !== null ? <h5>{Math.round(((originalPrice - price) * 100) / originalPrice)}<span><Icon name="percent" /></span> Off</h5> : '' }
            </div>
            {expiry ? <h6>{`Expiring on ${expiry.format('MMM DD, YYYY')}`}</h6> : ''}
          </div>
        </div>
      </div>
    );
  }
}

export default ProductCard;



// WEBPACK FOOTER //
// ./app/app-utils/card/ProductCard.jsx